import { type UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { type PayInParkingCardFormValues } from 'src/features/cards/components/PayInParkingCardModalForm';
import { paymentMethodOptions } from 'src/features/cards/utils/constants';
import { cardMessages } from 'src/features/cards/utils/messages';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { Input } from 'src/registry/ui/Input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/registry/ui/Select';

type PointActionFormProps = {
    form: UseFormReturn<PayInParkingCardFormValues>;
    onSubmit: (values: PayInParkingCardFormValues) => void;
};

function PayInParkingCardForm({ form, onSubmit }: PointActionFormProps) {
    const { formatMessage, formatNumber } = useIntl();
    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <FormField
                control={form.control}
                name="paid_amount"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog">{formatMessage(cardMessages.dueAmount)}</FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Input
                                    {...field}
                                    value={formatNumber(field.value, {
                                        style: 'currency',
                                        currency: 'BGN',
                                    })}
                                    placeholder="0.00"
                                    disabled
                                />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />

            <FormField
                control={form.control}
                name="payment_method"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            {formatMessage(cardMessages.paymentMethod)}
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Select onValueChange={field.onChange} defaultValue={field.value}>
                                    <SelectTrigger>
                                        <SelectValue
                                            placeholder={formatMessage(cardMessages.paymentMethodPlaceholder)}
                                        />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {paymentMethodOptions.map((paymentMethod) => (
                                            <SelectItem key={paymentMethod.value} value={paymentMethod.value}>
                                                {formatMessage(paymentMethod.label)}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
        </Form>
    );
}

export default PayInParkingCardForm;
